import { Body, Button, Stack } from '@qred/components-library';
import React from 'react';
import { PasscodeCardContent } from '~/components/shared/Passcode/PasscodeCardContent';
import { usePasscodeStatus } from '~/components/shared/Passcode/usePasscodeStatus';
import SpinnerCircular from '~/components/shared/Spinner/SpinnerCircular';
import useTranslate from '~/hooks/useTranslate';
import { theme } from '~/styles/themes';

export const PasscodeStep = () => {
  const translate = useTranslate();
  const status = usePasscodeStatus();

  if (status.status === 'loading') {
    return <SpinnerCircular color={theme.colors.secondaryGray} />;
  }

  if (status.status === 'error') {
    return (
      <Stack spacing="md" p="1.5em" data-testid="passcode-status-error">
        <Body size="lg" data-record>
          {translate('CreatePasscode.StatusError')}
        </Body>
        <Button
          size="md"
          variant="secondary"
          dataCy="passcode_status_retry_button"
          onClick={() => status.refetch()}
        >
          {translate('CreatePasscode.RetryButton')}
        </Button>
      </Stack>
    );
  }

  return (
    <PasscodeCardContent
      hasExistingPasscode={status.hasExistingPasscode}
      successDescription="CreatePasscode.SuccessDescriptionOffer"
    />
  );
};
